module.exports = __webpack_public_path__ + "static/portfolio-mas-6-aacc90ad668c9f71e2b01db44545065d.jpg";